import { render } from "./LinkageChangePasswordComplete.vue?vue&type=template&id=76c3295e&ts=true"
import script from "./LinkageChangePasswordComplete.vue?vue&type=script&lang=ts"
export * from "./LinkageChangePasswordComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src599522923/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__